import {NgModule} from '@angular/core';
import { MediaUploadModalComponent } from './item';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {ButtonComponentModule} from 'app/components/ui/button/item.module';
import {ModalHeaderComponentModule} from 'app/components/ui/modal-header/item.module';
import {DirectivesModule} from 'app/core/directives/directives.module';
import { ModalFooterComponentModule } from "app/components/ui/modal-footer/item.module";
import { IconComponentModule } from "app/components/ui/icon/item.module";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ButtonComponentModule,
    ModalHeaderComponentModule,
    DirectivesModule,
    ModalFooterComponentModule,
    IconComponentModule
  ],
  exports: [
    MediaUploadModalComponent
  ],
  declarations: [MediaUploadModalComponent],
  providers: [],
})
export class MediaUploadModalModule {
}
